export default __webpack_public_path__ + "static/media/process2.f59e0209.png";